import React from 'react';
import styles from '../../assets/styles/Orders/Orders.module.scss';
import { MimaButton, MimaDropdown, MimaText, Modal } from '../../components';
import { Formik } from 'formik';

const UpdateOrders = ({ closeModal, data, status, onSubmit, validationSchema, loading }) => {
    return (
        <Modal closeModal={closeModal}>
            <div className={styles.view_content}>
                <MimaText variant="subtitleBold" align="center" mb={5}>Update Order Status</MimaText>

                <MimaText variant="body" color="var(--color-primary)" >Order ID</MimaText>
                <MimaText variant="body2" mb={3}>{`ORD-${data.invoice.number}`}</MimaText>

                <MimaText variant="body" color="var(--color-primary)" >Customer Name</MimaText>
                <MimaText variant="body2" mb={3}>{data.invoice.customer.fullname}</MimaText>

            </div>
            <Formik
                initialValues={{
                    trackingStatus: data.trackingStatus ? data.trackingStatus : "",
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched,
                }) => (
                    <div>
                        <MimaDropdown
                            labelTitle="Order Status"
                            placeholder={data.trackingStatus ? data.trackingStatus : "Select Status"}
                            name="trackingStatus"
                            data={status}
                            onChange={data => {
                                setFieldValue("trackingStatus", data.value)
                            }}
                            value={values.trackingStatus}
                            error={errors.trackingStatus}
                            touched={touched.trackingStatus}
                        />

                        <MimaButton
                            title="Save"
                            onClick={() => {
                                handleSubmit(data._id)
                            }}
                            loading={loading}
                            mb={5}
                        />
                    </div>
                )}
            </Formik>
        </Modal>
    )
}
export default UpdateOrders;